
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiStarSelected as ObiStarSelectedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-star-selected.js';
 
 
 

 
 export const ObiStarSelected = createComponent({
   react: React,
   tagName: 'obi-star-selected',
   elementClass: ObiStarSelectedElement,
   events: {
     
   }
  });
 
 